/**
 * First Sale Tracker Step Factory
 *
 * Factory for creating, searching, and finding FirstSaleTrackerStep model instances.
 * Delegates CRUD operations to BaseModelFactory with the appropriate Service and Model.
 */

import BaseModelFactory from './base.factory'
import FirstSaleTrackerService from './../services/FirstSaleTracker.service'
import FirstSaleTrackerStep from './../models/first-sale-tracker-step.model'

class FirstSaleTrackerStepFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: FirstSaleTrackerService, Model: FirstSaleTrackerStep }
    )

  static findById = async id =>
    await this._findBy({ id: id }, { Service: FirstSaleTrackerService, Model: FirstSaleTrackerStep })

  static create = payload =>
    this._create(payload, {
      Service: FirstSaleTrackerService,
      Model: FirstSaleTrackerStep,
    })
}

export default FirstSaleTrackerStepFactory
